class PageNavigation {
  static initEvents() {
    (document.querySelectorAll<HTMLElement>(".menu-toggle")).forEach((el) => {
      el.addEventListener("click", PageNavigation.toggleMenu);
    });

    // Click Event to toggle Submenu for menu item with children
    (document.querySelectorAll<HTMLElement>(".menu-item-has-children")).forEach((menuItem) => {
      menuItem.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;
        const currentTarget = e.currentTarget as HTMLElement;

        if (target.tagName === "A") {
          return;
        }

        const isOpen = menuItem.classList.contains("open");

        (document.querySelectorAll<HTMLElement>(".menu-item-has-children")).forEach((el) => {
          el.classList.toggle("open", false);
        });
        currentTarget.classList.toggle("open", !isOpen);
      });
    });

    // Fix the navigation to the top of the page on scroll
    if (document.getElementById("page-navigation")) {
      const updatePageNavigationPosition = () => {
        const banner = document.getElementById("investor-portal-banner");
        const nav = document.getElementById("page-navigation");
        const top = window.scrollY;

        // Get the height of the banner or set it to 0
        const triggerHeight = banner ? banner.clientHeight : 0;

        if (nav !== null) {
          nav.classList.toggle("affixed", top > triggerHeight);
          document.body.classList.toggle("scrolled", top > triggerHeight);
        }
      };

      updatePageNavigationPosition();
      window.addEventListener("scroll", updatePageNavigationPosition);
    }

    if (document.body.classList.contains("home")) {
      (document.querySelectorAll<Element>("[href^='/#']") ?? []).forEach((link) => {
        link.addEventListener("click", () => {
          document.documentElement.classList.remove("menu-open");
          PageNavigation.changeToggleIcon();
        });
      });
    }

    window.addEventListener("DOMContentLoaded", PageNavigation.moveToHash);
  }

  static toggleMenu(e: MouseEvent) {
    e.preventDefault();
    document.documentElement.classList.toggle("menu-open");
    PageNavigation.changeToggleIcon();
  }

  static moveToHash() {
    if (window.location.hash) {
      window.scroll(0, 0);

      const event = new CustomEvent("animate.scroll", {
        detail: document.querySelector<Element>(window.location.hash) ?? 0,
      });

      window.dispatchEvent(event);

      document.documentElement.classList.remove("menu-open");
      PageNavigation.changeToggleIcon();
    }
  }

  static changeToggleIcon() {
    const isOpen = document.documentElement.classList.contains("menu-open");

    (document.querySelectorAll<HTMLElement>(".menu-toggle use")).forEach((el) => {
      el.setAttribute("xlink:href", isOpen ? "#menu--close" : "#menu--bars");
    });
  }

  static clearHash() {
    window.history.pushState("", document.title, window.location.pathname + window.location.search);
  }
}

PageNavigation.initEvents();
